<template>
  <div class="score" v-show="this.detailsManyData.resultMap&&this.detailsManyData.resultMap.moraleAVG">
    <div class="myCharts">
      <div class="bt">
        <img src="../../../assets/icon_emotion.png" alt="" />
        <span style="position: relative;top: 4px;" v-if="this.detailsManyData.resultMap&&this.detailsManyData.resultMap.moraleAVG">
			情绪值  平均{{ detailsManyData.resultMap.moraleAVG.toFixed(0) }}</span>
      </div>
      <div
        id="myChartMorales"
        style="height: 126px; margin: 10px auto"
        key="scores"
      ></div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    score: 0,
    detailsManyData: {},
    dataTitleList: null,
  },
  data() {
    return {
      myChartMorales: null,
      good: 0,
    };
  },
  methods: {
    getChartMorales() {
	  if (this.myChartMorales != null && this.myChartMorales!= "" && this.myChartMorales!= undefined) {
	  	this.myChartMorales.dispose();
	  }
      this.myChartMorales = this.$echarts.init(
        document.getElementById("myChartMorales")
      );
	  var moraleX = [];
	  for(var i = 0; i < this.detailsManyData.resultMap.moraleX.length; i++){
	  		  moraleX[i] = this.detailsManyData.resultMap.moraleX[i].replace(",", "-");
	  }
	  var moraleY = [];
	  for(var i = 0; i < this.detailsManyData.resultMap.moraleY.length; i++){
	  		  if(this.detailsManyData.resultMap.moraleY[i] != 0){
	  			  moraleY[i] = this.detailsManyData.resultMap.moraleY[i];
	  		  }else {
	  			  moraleY[i] = null;
	  		  }
	  }
      var optionScore = {
        color: ["#1890FF"],
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          // borderWidth: 1,
          borderRadius: 5,
          //   formatter: function (params) {
          //     console.log(params[0].data);
          //     return params[0].data;
          //   },
        },
        grid: {
          left: "0%",
          right: "0%",
          top: "10%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
            },
            //data: this.detailsManyData.resultMap.moraleX,
			data: moraleX,
          },
        ],

        yAxis: [
          {
            type: "value",
            min: 0,
            max: 100,
            logBase: 10,
            interval: 100,
            splitLine: {
              show: false,
            },
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: true,
            },
          },
        ],
        series: [
          {
            //data: this.detailsManyData.resultMap.moraleY,
			data: moraleY,
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            color: "#1890FF",
            markLine: {
              symbol: "none",
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
              data: [
                {
                  silent: false, //鼠标悬停事件  true没有，false有
                  lineStyle: {
                    //警戒线的样式  ，虚实  颜色
                    type: "dashed",
                    color: "#C394FE",
                  },
                  label: {
                    position: "end",
                    formatter: "",
                  },
                  yAxis: this.detailsManyData.resultMap.moraleAVG, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
              ],
            },
          },
        ],
      };

      this.myChartMorales.clear();
      this.myChartMorales.setOption(optionScore);
      window.addEventListener("resize", () => {
        this.myChartMorales.resize();
      });

      
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
</style>
